module.exports = __webpack_public_path__ + "img/pay.32ac9bfb.png";